import React, { lazy } from 'react';

const isChunkLoadError = (error: unknown): boolean => {
  if (!(error instanceof Error)) {
    return false;
  }

  const message = error.message || '';
  return (
    message.includes('ChunkLoadError') ||
    message.includes('Loading chunk') ||
    message.includes('Failed to fetch dynamically imported module')
  );
};

export const lazyWithRetry = <T extends { default: React.ComponentType<any> }>(
  importer: () => Promise<T>,
  retryKey: string
) =>
  lazy(async () => {
    const storageKey = `lazy-reload:${retryKey}`;
    const alreadyRetried = sessionStorage.getItem(storageKey) === '1';

    try {
      const module = await importer();
      sessionStorage.removeItem(storageKey);
      return module;
    } catch (error) {
      if (isChunkLoadError(error) && !alreadyRetried) {
        sessionStorage.setItem(storageKey, '1');
        window.location.reload();
        return new Promise<T>(() => {
          // Intentionally never resolves; page reload takes over.
        });
      }

      throw error;
    }
  });

